module.exports = __webpack_public_path__ + "media/images/mv_img_sp2-0ea831ed4ec9e3a9bfb193491693f1bd.png";